import type { IScheduleInMedcenter } from '@/entities/medcenter/model/types';

interface IMedcenterScheduleOptions {
  is24HoursWork: number[] | 'all' | 'none';
  isWork: number[] | 'all' | 'none';
}

const isDayInArray = (day: number, days: number[] | 'all' | 'none'): boolean => {
  if (days === 'all') return true;
  if (days === 'none') return false;

  return days.includes(day);
};

export const genMedcenterSchedule = (options: IMedcenterScheduleOptions): IScheduleInMedcenter[] => {
  if (!options) return [];

  const { is24HoursWork = 'none', isWork = 'none' } = options;
  const schedule: IScheduleInMedcenter[] = [];

  for (let day = 1; day <= 7; day++) {
    const isWorkDay = isDayInArray(day, isWork);
    const is24Hours = isDayInArray(day, is24HoursWork);

    schedule.push({
      day,
      isWork: isWorkDay,
      startTime: isWorkDay ? '08:00' : null,
      endTime: isWorkDay ? '19:00' : null,
      is24HoursWork: is24Hours,
    });
  }

  return schedule;
};
